import { isEmpty } from "@swiggy-private/js-utils";
import { addRequestInterceptor, addResponseInterceptor } from "@swiggy-private/native-bridge";
import type { NativeRequest } from "@swiggy-private/native-bridge";
import { filterHeadersFromSwiggyHeaders, getAuthHeaders } from "./utils";

const getPrefix = (prefix?: string): string => (!isEmpty(prefix) ? `${prefix}_` : "");

export const createNBRequestInterceptor = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    recordNREvent?: (event: any) => void,
    prefix?: string,
): VoidFunction =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    addRequestInterceptor((req: NativeRequest<{ state?: string }>) => {
        if (recordNREvent == null) {
            return;
        }
        const projectPrefix = getPrefix(prefix);
        const headers = getAuthHeaders();
        const swgyHeaders = headers ? filterHeadersFromSwiggyHeaders(headers) : {};
        recordNREvent({
            eventType: `${projectPrefix}web_native_bridge_request`,
            id: req.requestId,
            type: req.type,
            subType: req.payload?.state ?? "",
            ...swgyHeaders,
        });
    });

export const createNBResponseInterceptor = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    recordNREvent?: (event: any) => void,
    prefix?: string,
): VoidFunction =>
    addResponseInterceptor((res) => {
        if (recordNREvent == null) {
            return;
        }
        const projectPrefix = getPrefix(prefix);
        const headers = getAuthHeaders();
        const swgyHeaders = headers ? filterHeadersFromSwiggyHeaders(headers) : {};
        recordNREvent({
            eventType: `${projectPrefix}web_native_bridge_response`,
            id: res.requestId,
            type: res.type,
            statusCode: res.statusCode ?? -1,
            statusMessage: res.statusMessage ?? "",
            bridgeType: res.bridgeType ?? "",
            ...swgyHeaders,
        });
    });
